import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginRequest } from '../models/login-request.model';
import { map, Observable } from 'rxjs';
import { environment } from "src/environments/environment";


@Injectable()
export class LoginService {

  constructor(private http: HttpClient) { }

  login(login: LoginRequest): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${environment.baseUrl}/api/login`, login, { withCredentials: true });
  }
}
